// src/pages/finance/SaldoAplikasiPage.js
import React, { useEffect, useState } from 'react'
import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore'
import { db } from '../../firebaseConfig'
import * as XLSX from 'xlsx' // 👈 TAMBAHAN IMPORT EXCEL

export default function SaldoAplikasiPage({ orders }) { // 👈 Terima prop
  const [recentIncomes, setRecentIncomes] = useState([])

  // 👈 TAMBAHAN STATE TANGGAL
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  // 1. Hitung Total Pendapatan langsung dari props 'orders'
  const totalRevenue = orders.reduce((acc, curr) => acc + (curr.commissionDeducted || 0), 0)

  // 2. Fungsi Filter Lokal (Mencegah Query Ulang Database)
  const handleFilterLocal = () => {
    let filtered = orders.map(data => ({
      id: data.id,
      orderId: data.orderId,
      service: data.serviceName || 'Layanan',
      fee: data.commissionDeducted || 0,
      date: data.date
    }))

    if (startDate && endDate) {
      const start = new Date(startDate)
      start.setHours(0, 0, 0, 0)
      
      const end = new Date(endDate)
      end.setHours(23, 59, 59, 999)

      filtered = filtered.filter(item => item.date >= start && item.date <= end)
    } else {
      filtered = filtered.slice(0, 50) // Fallback 50 transaksi
    }

    setRecentIncomes(filtered)
  }

  // Auto-update tabel saat data orders dari Parent berubah
  useEffect(() => {
    handleFilterLocal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders])

  // 👈 FUNGSI EXPORT KE EXCEL
  const handleExportExcel = () => {
    if (recentIncomes.length === 0) return alert('Tidak ada data untuk diekspor.')

    // Mapping data spesifik untuk kolom Excel
    const dataToExport = recentIncomes.map((item, index) => ({
      'No': index + 1,
      'Tanggal': item.date.toLocaleDateString('id-ID'),
      'Waktu': item.date.toLocaleTimeString('id-ID'),
      'ID Order': item.orderId,
      'Layanan': item.service,
      'Nilai Komisi Masuk (Rp)': item.fee
    }))

    // Membuat worksheet & workbook
    const worksheet = XLSX.utils.json_to_sheet(dataToExport)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Pemasukan Komisi")

    // Penamaan file cerdas berdasarkan filter
    const fileName = (startDate && endDate) 
      ? `Laporan_Komisi_Zimo_${startDate}_sd_${endDate}.xlsx` 
      : `Laporan_Komisi_Zimo_Terbaru.xlsx`

    XLSX.writeFile(workbook, fileName)
  }

  return (
    <div>
      {/* HEADER CARD */}
      <div className="bg-gradient-to-r from-blue-900 to-indigo-900 p-6 rounded-xl border border-blue-800 shadow-lg mb-8">
        <h2 className="text-blue-200 text-sm font-medium mb-1">Total Saldo Aplikasi (Estimasi Pendapatan)</h2>
        <h1 className="text-4xl font-bold text-white">
          Rp {totalRevenue.toLocaleString('id-ID')}
        </h1>
        <p className="text-blue-300 text-xs mt-2 opacity-80">
          *Akumulasi dari potongan komisi transaksi
        </p>
      </div>

      {/* RECENT TRANSACTIONS & FILTER TANGGAL */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-4">
        <h3 className="text-lg font-bold text-gray-100">📥 Rincian Pemasukan (Komisi)</h3>
        
        {/* 👈 UI FILTER DAN EXPORT */}
        <div className="flex flex-wrap items-center gap-2">
          <input 
            type="date" 
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="bg-gray-800 border border-gray-700 text-sm rounded-lg p-2 text-white outline-none focus:border-blue-500"
          />
          <span className="text-gray-400 text-sm">s/d</span>
          <input 
            type="date" 
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="bg-gray-800 border border-gray-700 text-sm rounded-lg p-2 text-white outline-none focus:border-blue-500"
          />
          
          <button 
            onClick={handleFilterLocal}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-bold transition shadow-lg"
          >
            Cari
          </button>

          <button 
            onClick={handleExportExcel}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm font-bold transition shadow-lg flex items-center gap-2"
          >
            📊 Export Excel
          </button>
        </div>
      </div>
      
      <div className="bg-gray-800 border border-gray-700 rounded-lg overflow-hidden">
        {!orders ? (
          <div className="p-6 text-center text-gray-400">Loading keuangan...</div>
        ) : (
          <table className="w-full text-left text-sm text-gray-300">
            <thead className="bg-gray-700 text-gray-400 uppercase font-semibold">
              <tr>
                <th className="px-6 py-3">Tanggal</th>
                <th className="px-6 py-3">Order ID</th>
                <th className="px-6 py-3">Layanan</th>
                <th className="px-6 py-3 text-right">Nilai Komisi</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {recentIncomes.length === 0 ? (
                <tr>
                  <td colSpan="4" className="px-6 py-4 text-center">Belum ada data pemasukan.</td>
                </tr>
              ) : (
                recentIncomes.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-700/50 transition">
                    <td className="px-6 py-3 text-gray-400">
                      {item.date.toLocaleString('id-ID')}
                    </td>
                    <td className="px-6 py-3 font-mono text-white">
                      {item.orderId}
                    </td>
                    <td className="px-6 py-3">
                      {item.service}
                    </td>
                    <td className="px-6 py-3 text-right font-bold text-green-400">
                      + Rp {item.fee.toLocaleString('id-ID')}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}